export const VISUALIZATION_TYPES = {
  VISUALIZATION: "Visualización",
  ACTIVITY: "actividad",
};